export const routes = {
  dashboard: "/",
  sessions: {
    new: "/session/new",
    create: "/session",
    destroy: "/session",
  },
  subjects: {
    index: "/subjects",
    new: "/subjects/new",
    create: "/subjects",
    show: (id: number) => `/subjects/${id}`,
    edit: (id: number) => `/subjects/${id}/edit`,
    update: (id: number) => `/subjects/${id}`,
    destroy: (id: number) => `/subjects/${id}`,
  },
  tutors: {
    index: "/tutors",
    show: (id: number) => `/tutors/${id}`,
    edit: (id: number) => `/tutors/${id}/edit`,
    update: (id: number) => `/tutors/${id}`,
    verify: (id: number) => `/tutors/${id}/verify`,
  },
  bookings: {
    index: "/bookings",
    show: (id: number) => `/bookings/${id}`,
    confirm: (id: number) => `/bookings/${id}/confirm`,
    cancel: (id: number) => `/bookings/${id}/cancel`,
  },
  conversations: {
    index: "/conversations",
    show: (id: number) => `/conversations/${id}`,
  },
  parents: {
    index: "/parents",
    show: (id: number) => `/parents/${id}`,
    edit: (id: number) => `/parents/${id}/edit`,
    update: (id: number) => `/parents/${id}`,
  },
  jobs: {
    index: "/jobs",
    show: (id: number) => `/jobs/${id}`,
    retry: (id: number) => `/jobs/${id}/retry`,
    destroy: (id: number) => `/jobs/${id}`,
  },
  admins: {
    index: "/admins",
    new: "/admins/new",
    create: "/admins",
  },
  users: {
    index: "/users",
  },
  tutorSubjects: {
    create: (tutorId: number) => `/tutors/${tutorId}/tutor_subjects`,
    update: (tutorId: number, id: number) => `/tutors/${tutorId}/tutor_subjects/${id}`,
    destroy: (tutorId: number, id: number) => `/tutors/${tutorId}/tutor_subjects/${id}`,
  },
};
